import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {RouterOutlet} from "@angular/router";
import {FooterComponent} from "./components/pages/footer/footer.component";
import {HeaderComponent} from "./components/pages/header/header.component";
import {JobsComponent} from './components/pages/jobs/jobs.component';
import {AppRoutingModule} from "./app-routing.module";
import {
  JobAttachmentsDetailsComponent
} from './components/pages/job-attachments-details/job-attachments-details.component';
import {QuotesComponent} from './components/pages/quotes/quotes.component';
import {AssetsComponent} from './components/pages/assets/assets.component';
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {SignInComponent} from './components/pages/sign-in/sign-in.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {DashboardComponent} from './components/pages/dashboard/dashboard.component';
import {
  DonutChartComponent
} from './components/pages/dashboard/dashboard-charts/dashboard-item/donut-chart/donut-chart.component';
import {NgApexchartsModule} from "ng-apexcharts";
import {NgxEchartsModule} from "ngx-echarts";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ToastComponent} from './components/custom-components/toast/toast.component';
import {ToastsComponent} from './components/custom-components/toasts/toasts.component';
import {RegisterComponent} from './components/pages/register/register.component';
import {InvoicesComponent} from './components/pages/invoices/invoices.component';
import {ForgotPasswordComponent} from './components/pages/forgot-password/forgot-password.component';
import {EmailVerificationComponent} from './components/pages/email-verification/email-verification.component';
import {ResetPasswordComponent} from './components/pages/reset-password/reset-password.component';
import {ApiRequestInterceptor} from "./interceptors/api-request.interceptor";
import {PendingUsersComponent} from './components/pages/pending-users/pending-users.component';
import {JobComponent} from './components/pages/job/job.component';
import {QuoteComponent} from './components/pages/quote/quote.component';
import {QuoteApprovePopupComponent} from './components/pages/quote/quote-approve-popup/quote-approve-popup.component';
import {QuoteAttachmentsComponent} from './components/pages/quote/quote-attachments/quote-attachments.component';
import {
  QuoteAttachmentsDetailsComponent
} from "./components/pages/quote-attachments-details/quote-attachments-details.component";
import {CommentsSectionComponent} from './components/custom-components/comments-section/comments-section.component';
import {HistoryTableComponent} from './components/custom-components/history-table/history-table.component';
import {JobAttachmentsComponent} from './components/pages/job/job-attachments/job-attachments.component';
import {DashboardChartsComponent} from './components/pages/dashboard/dashboard-charts/dashboard-charts.component';
import {ServiceRequestComponent} from './components/pages/service-request/service-request.component';
import {
  ServiceRequestAssetComponent
} from './components/pages/service-request/service-request-asset/service-request-asset.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {ServiceRequestsComponent} from "./components/pages/service-requests/service-requests.component";
import {InvitedUsersComponent} from "./components/pages/invited-users/invited-users.component";
import {CompleteRegistrationComponent} from "./components/pages/complete-registration/complete-registration.component";
import {
  ServiceRequestPopupComponent
} from "./components/pages/header/authorized-header/service-request-popup/service-request-popup.component"
import {
  SubmitServiceRequestPopupComponent
} from "./components/pages/service-request/submit-service-request-popup/submit-service-request-popup.component";
import {ConfirmModalComponent} from "./components/custom-components/confirm-modal/confirm-modal.component";
import {
  DashboardItemComponent
} from "./components/pages/dashboard/dashboard-charts/dashboard-item/dashboard-item.component";
import {LogoComponent} from "./components/pages/header/components/logo/logo.component";
import {NavigationItemComponent} from "./components/pages/header/components/navigation-item/navigation-item.component";
import {UnauthorizedHeaderComponent} from "./components/pages/header/unauthorized-header/unauthorized-header.component";
import {AuthorizedHeaderComponent} from "./components/pages/header/authorized-header/authorized-header.component";
import {UserProfileComponent} from "./components/pages/header/components/profile/profile.component";
import {CustomTableComponent} from "./components/custom-components/custom-table/custom-table.component";
import {ClickOutsideDirective} from "./directives/click-outside.directive";
import {LoadingOverlayComponent} from "./components/custom-components/loading-overlay/loading-overlay.component";
import {StopClickPropagationDirective} from "./directives/stop-click-propagation.directive";
import {AvatarIconComponent} from "./components/custom-components/avatar-icon/avatar-icon.component";
import {LoadingPulseComponent} from "./components/custom-components/loading-pulse/loading-pulse.component";
import {AttachmentCardComponent} from "./components/custom-components/attachment-card/attachment-card.component";
import {LoadingSpinnerComponent} from "./components/custom-components/loading-spinner/loading-spinner.component";
import {
  KeyValuePairTableComponent
} from "./components/custom-components/key-value-pair-table/key-value-pair-table.component";
import {TagsComponent} from "./components/custom-components/tags/tags.component";
import {
  PendingUserApproveModal
} from "./components/pages/pending-users/pending-user-approve-modal/pending-user-approve-modal";
import {CustomIcon} from "./components/custom-components/custom-icon/custom-icon";
import {NewVersionBannerComponent} from "./components/custom-components/new-version-banner/new-version-banner.component";

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    JobsComponent,
    QuotesComponent,
    AssetsComponent,
    SignInComponent,
    DashboardComponent,
    DonutChartComponent,
    DashboardItemComponent,
    ToastComponent,
    ToastsComponent,
    RegisterComponent,
    InvoicesComponent,
    ForgotPasswordComponent,
    EmailVerificationComponent,
    ResetPasswordComponent,
    PendingUsersComponent,
    InvitedUsersComponent,
    CompleteRegistrationComponent,
    JobComponent,
    QuoteComponent,
    QuoteApprovePopupComponent,
    QuoteAttachmentsComponent,
    CommentsSectionComponent,
    HistoryTableComponent,
    JobAttachmentsComponent,
    DashboardChartsComponent,
    ServiceRequestComponent,
    ServiceRequestAssetComponent,
    ServiceRequestsComponent,
    ServiceRequestPopupComponent,
    JobAttachmentsDetailsComponent,
    QuoteAttachmentsDetailsComponent,
    ConfirmModalComponent,
    AuthorizedHeaderComponent,
    NavigationItemComponent,
    UnauthorizedHeaderComponent,
    LogoComponent,
    UserProfileComponent,
    LoadingOverlayComponent
  ],
  imports: [
    AppRoutingModule,
    HttpClientModule,
    NgApexchartsModule,
    BrowserModule,
    CommonModule,
    RouterOutlet,
    NgOptimizedImage,
    ReactiveFormsModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    FormsModule,
    NgSelectModule,
    SubmitServiceRequestPopupComponent,
    CustomTableComponent,
    ClickOutsideDirective,
    StopClickPropagationDirective,
    AvatarIconComponent,
    LoadingPulseComponent,
    AttachmentCardComponent,
    LoadingSpinnerComponent,
    KeyValuePairTableComponent,
    TagsComponent,
    PendingUserApproveModal,
    CustomIcon,
    NewVersionBannerComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiRequestInterceptor,
      multi: true
    }
  ],
  exports: [
    ServiceRequestPopupComponent,
    NavigationItemComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
